import React from 'react';
import { inject,observer } from 'mobx-react';
import * as mobx from 'mobx';
import * as _ from '../../util/public/common';

export default class Main extends React.Component{
    render(){
        return (
            <span>SubmitInfo</span>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/topPropmpt/SubmitInfo.js